import React from 'react';

import classNames from 'classnames';

import Timestamp from './Timestamp';

import classes from './styles.module.scss';

export default function Timestamps({ section, scrollWidth }) {
  const count = Math.ceil(scrollWidth / 190);

  return (
    <div
      className={classNames(classes.Timestamps, {
        [classes.single]: count <= 1,
      })}
      style={{ width: scrollWidth }}
    >
      {Array.from({ length: Math.max(2, count) }).map((_, index) => {
        return (
          <Timestamp
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            isFirst={index === 0}
            isLast={index === count - 1}
            section={section}
            scrollWidth={scrollWidth}
          />
        );
      })}
    </div>
  );
}
